import React from 'react';
import ReportSelectionMenu from '../common/reportSelectionMenu';
import EntityIdentRow from '../layoutItems/entityIdentRow';
import { isOnPath } from '../../store/apiWrapper';

class WarningsReportHeader extends React.Component {
    render() {
        if (this.props.isMobile) {
            return <EntityIdentRow entityId={window.location.pathname.match(/\d+/)[0]} isMobile={true} isWarning/>;
        }
        return (<>
            <EntityIdentRow entityId={window.location.pathname.match(/\d+/)[0]} shadowed={false} sticky={isOnPath({ regex: /\/(((report)\/([\w-]+)))\/(\d+).*/i })} right={this.props.right} isWarning unlimited/>
        </>)
    }
}

export default WarningsReportHeader;